import React, { useContext } from "react";
import { css } from "@emotion/css";

import LogInButton from "./LogInButton";
import MicrosoftLogo from "./MicrosoftLogo";
import { UserContext } from "../../contexts/UserContext";

const styles = css`
  background-color: currentColor;
  & h1 {
    font-size: 1.5em;
    margin: 0;
    padding: 0;
  }

  & .img-wrapper {
    height: 100%;
    padding: 0 8px;
    background-color: currentColor;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  & h1 span {
    color: white;
  }

  & h1 span:first-of-type {
    font-weight: 600;
    padding: 0 8px;
  }

  & h1 span:nth-of-type(2) {
    font-weight: 100;
  }
`;

export const Header: React.FC = () => {
  const { user, login, logout } = useContext(UserContext);
  return (
    <header className={styles}>
      <div className="img-wrapper">
        <MicrosoftLogo color="white" />
      </div>
      <h1>
        <span>JEM</span>
        <span>Subledger</span>
      </h1>
      <LogInButton user={user} login={login} logout={logout} />
    </header>
  );
};

export default Header;
